/// <reference path="../app.ts" />
namespace Cfnc {

    export interface IsavedSearchService {
        name: string;
        setName: (value: string) => void;
        getName: () => string;
    }

    export class SavedSearchService implements IsavedSearchService {
        name: string;

        public setName(value: string) {
            this.name = value;
        }

        public getName() {
            return this.name == "undefined" ? null : this.name;
        }
    }

    angular.module("app").service("savedSearchService", SavedSearchService);
}